const ALLOWED_TAGS = new Set([
  'B', 'STRONG', 'I', 'EM', 'U', 'S', 'STRIKE', 'BR', 'SPAN', 'DIV', 'P',
]);

function unwrap(node: Element): void {
  const parent = node.parentNode;
  if (!parent) return;
  while (node.firstChild) parent.insertBefore(node.firstChild, node);
  parent.removeChild(node);
}

function clean(node: Node): void {
  if (node.nodeType !== Node.ELEMENT_NODE) return;
  const el = node as Element;
  const children = Array.from(el.childNodes);
  for (const child of children) clean(child);

  if (!ALLOWED_TAGS.has(el.tagName)) {
    unwrap(el);
    return;
  }

  for (const attr of Array.from(el.attributes)) {
    el.removeAttribute(attr.name);
  }
}

export function sanitizeOverlayHtml(html: string): string {
  if (!html) return '';
  if (typeof DOMParser === 'undefined') return html;
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
  const root = doc.body.firstElementChild as HTMLElement | null;
  if (!root) return '';
  for (const child of Array.from(root.childNodes)) clean(child);
  return root.innerHTML;
}

export function htmlToPlainText(html: string): string {
  if (!html) return '';
  if (typeof DOMParser === 'undefined') return html.replace(/<[^>]+>/g, '');
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
}

/**
 * Does this editor HTML show anything? A contentEditable left empty keeps
 * `<br>` / `<div><br></div>` / `&nbsp;` behind, which is not text: the card
 * shows the element's placeholder for it and the renders give it no space.
 */
export function hasVisibleText(html: string | null | undefined): boolean {
  if (!html) return false;
  return html.replace(/<[^>]*>/g, '').replace(/&nbsp;|\u00a0/g, ' ').trim().length > 0;
}

/** The sanitized value to keep: '' when nothing is visible, so a cleared box
 * is stored as empty rather than as the editor's leftover markup. */
export function emptyIfBlank(html: string): string {
  return hasVisibleText(html) ? html : '';
}
